import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Component, Inject, Input, NgModule } from '@angular/core';
import * as i1 from '@upr-web-primer/gds-common-utility';
import { GdsCommonUtilityModule } from '@upr-web-primer/gds-common-utility';
import * as i1$2 from '@upr-web-primer/gds-data-model';
import { GdsDataModelModule, GdsDataModelService } from '@upr-web-primer/gds-data-model';
import { get, set } from 'lodash-es';
import * as i2 from '@upr-web-primer/gds-modal';
import { GdsModalModule, GdsModalService } from '@upr-web-primer/gds-modal';
import * as i1$1 from '@upr-web-primer/gds-button-model-service';
import { GdsButtonModelService } from '@upr-web-primer/gds-button-model-service';
import * as i2$1 from '@upr-web-primer/page-labels';
import { PageLabelsResolver } from '@upr-web-primer/page-labels';
import { take } from 'rxjs';
import { GdsImageLinkModelService } from '@upr-web-primer/gds-image-link-model';
import { GdsPictureModelService } from '@upr-web-primer/gds-picture-model';
import { GdsPoiService } from '@upr-web-primer/gds-poi';
import { GdsRouteResolverService } from '@upr-web-primer/gds-route-resolver';
import { GdsTextService } from '@upr-web-primer/gds-text';
import { GdsTripAdvisorService } from '@upr-web-primer/gds-trip-advisor';
import { GdsVideoModelService } from '@upr-web-primer/gds-video-model';
import { GdsYoutubeService } from '@upr-web-primer/gds-youtube';
import { LocaleService } from '@upr-web-primer/locale';
import { SessionStorageService, LocalStorageService } from '@upr-web-primer/storage';

class GdsButtonService {
    constructor(utilities, gdsModalService) {
        this.utilities = utilities;
        this.gdsModalService = gdsModalService;
    }
    init(elementRef, data, contentType = 'static') {
        this.elementRef = elementRef;
        this.data = data;
        this.contentType = contentType;
        this.interceptBtnClicks();
    }
    interceptBtnClicks() {
        this.elementRef.nativeElement.addEventListener('buttonClicked', (event) => {
            this.buttonEventHandler(event);
        }, false);
    }
    buttonEventHandler(event) {
        const btnData = get(event, 'detail.data.button') ||
            get(event, 'detail.data') ||
            get(event, 'detail.data.background.link');
        if (!btnData) {
            event.stopImmediatePropagation();
            return;
        }
        const btnType = get(btnData, 'type') || get(event, 'detail.data.background.link.type');
        if (btnType === 'right-arrow' || btnType === 'left-arrow') {
            event.stopImmediatePropagation();
            return;
        }
        const btnTarget = get(btnData, 'target') ||
            get(event, 'detail.data.background.link.target');
        if (this.utilities.isModal(btnTarget, btnType)) {
            this.gdsModalService.loadModal(btnData, this.data, this.utilities.getContrast(), event, '', this.contentType !== 'ms-content');
            event.stopImmediatePropagation();
        }
    }
}
GdsButtonService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsButtonService, deps: [{ token: i1.GdsCommonUtilityService }, { token: i2.GdsModalService }], target: i0.ɵɵFactoryTarget.Injectable });
GdsButtonService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsButtonService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsButtonService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.GdsCommonUtilityService }, { type: i2.GdsModalService }]; } });

class GdsComparisonTableService {
    constructor(buttonDataMapper, pageLabelsResolver) {
        this.buttonDataMapper = buttonDataMapper;
        this.pageLabelsResolver = pageLabelsResolver;
        if (this.pageLabelsResolver) {
            this.pageLabelsResolver.$pageLabels
                .pipe(take(1))
                .subscribe((pageLabels) => {
                this.pageLabels = pageLabels;
            });
        }
    }
    setComparisonTableData(comparisonTableData) {
        comparisonTableData?.items?.forEach((item) => {
            item.attributes = item?.attributes?.map((attribute) => {
                return {
                    key: attribute?.attribute?.Key || '',
                    title: attribute?.attribute?.MetadataFields?.title?.Values[0] || '',
                    description: attribute?.attribute?.MetadataFields?.description?.Values[0] || '',
                    button: attribute?.attribute?.MetadataFields?.button
                        ? this.buttonDataMapper.init(attribute?.attribute?.MetadataFields?.button)
                        : null,
                    icon: attribute?.icon || '',
                    value: attribute?.value || '',
                    section: attribute.attribute?.parentKeywords || '',
                };
            });
        });
        const sections = comparisonTableData?.sections;
        if (!!sections) {
            if (Array.isArray(sections)) {
                comparisonTableData.sections = sections.map((section) => {
                    return section.Title;
                });
            }
            else {
                comparisonTableData.sections = [sections.Key];
            }
        }
        const resources = comparisonTableData?.resources?.Resource || [];
        [
            'CTOrLabel',
            'CTDefaultValue',
            'CTExpandAll',
            'CTCollapseAll',
            'CTAddButtonValue',
            'CTRemoveButtonValue',
            'CTAvailable',
            'CTNotAvailable',
            'CTUpdateProductLiveRegion',
        ].forEach((key) => {
            comparisonTableData.resources[key] = this.getResourceValue(resources, key);
        });
        delete comparisonTableData?.resources?.Resource;
        return comparisonTableData;
    }
    getResourceValue(resources, key) {
        if (!resources?.length)
            return '';
        const value = resources?.find((resource) => resource.Key === key)?.Value;
        return value || this.pageLabels[key] || '';
    }
}
GdsComparisonTableService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsComparisonTableService, deps: [{ token: i1$1.GdsButtonModelService }, { token: i2$1.PageLabelsResolver }], target: i0.ɵɵFactoryTarget.Injectable });
GdsComparisonTableService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsComparisonTableService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsComparisonTableService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.GdsButtonModelService }, { type: i2$1.PageLabelsResolver }]; } });

class GdsFlexibleContainerService {
    init() {
        console.log('transclude linked component values');
    }
}
GdsFlexibleContainerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsFlexibleContainerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GdsFlexibleContainerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsFlexibleContainerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsFlexibleContainerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class GdsSwimlaneService {
    filterSwimlaneItems(tcmContent, gdsData) {
        const cardType = get(tcmContent, 'Component.MetadataFields.card_type.KeywordValues[0].Key') || get(tcmContent, 'component[0].card_type');
        const cards = get(gdsData, 'items', []);
        const filteredCards = cards?.filter((item) => cardType === item.card_type);
        return set(gdsData, 'items', filteredCards);
    }
}
GdsSwimlaneService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsSwimlaneService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GdsSwimlaneService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsSwimlaneService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsSwimlaneService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class GdsTcmLoaderComponent {
    constructor(document, element, gdsDataModelService, gdsSwimlaneService, gdsComparisonTableService, gdsFlexibleContainerService, gdsButtonService, renderer, utilities) {
        this.document = document;
        this.element = element;
        this.gdsDataModelService = gdsDataModelService;
        this.gdsSwimlaneService = gdsSwimlaneService;
        this.gdsComparisonTableService = gdsComparisonTableService;
        this.gdsFlexibleContainerService = gdsFlexibleContainerService;
        this.gdsButtonService = gdsButtonService;
        this.renderer = renderer;
        this.utilities = utilities;
        this.tcmCtTitle = '';
        this.gdsElementTag = '';
        this.gdsTemplateType = '';
        this.gdsData = undefined;
    }
    ngOnInit() {
        if (!this.data)
            return;
        this.parseTcmMeta();
        this.buildGdsComponent();
    }
    parseTcmMeta() {
        this.dataSrc = get(this.data, 'componentTemplate')
            ? 'ms-content'
            : 'tridion-page';
        this.tcmCtTitle = get(this.data, 'ComponentTemplate.Title');
        this.tcmContent =
            get(this.data, 'Component.Fields') || get(this.data, 'component[0]');
        this.gdsElementTag =
            get(this.data, 'ComponentTemplate.MetadataFields.name.Values[0]') ||
                get(this.data, 'componentTemplate.Meta.name', '');
        this.tcmMetaAttributes =
            get(this.data, 'ComponentTemplate.MetadataFields.attributes.EmbeddedValues') || get(this.data, 'componentTemplate.Meta.attributes');
        this.tcmMetaTagType = get(this.data, 'Component.MetadataFields.tagType.KeywordValues[0].Key', '');
    }
    buildGdsComponent() {
        this.createGdsElement();
        this.parseTcmContent();
        this.parseTcmTemplateType();
        this.setGdsAttributes();
        this.setGdsTagType();
        this.setGdsContrast();
        this.setGdsTheme();
        this.attachBtnInterceptor();
        this.specificParsers();
    }
    createGdsElement() {
        this.gdsComponent = this.document.createElement(this.gdsElementTag);
    }
    parseTcmContent() {
        if (this.dataSrc === 'tridion-page') {
            this.gdsData = this.gdsDataModelService.init(this.tcmContent);
        }
        else if (this.dataSrc === 'ms-content') {
            this.gdsData = this.gdsDataModelService.parseContent(this.tcmContent);
        }
    }
    parseTcmTemplateType() {
        if (!this.tcmMetaAttributes?.length)
            return;
        this.tcmMetaAttributes.forEach((keyValue) => {
            if (keyValue) {
                const _key = get(keyValue, 'key.Values[0]');
                const _value = get(keyValue, 'value.Values[0]');
                if (_value !== '{{data}}') {
                    if (_key === 'type') {
                        this.gdsTemplateType = _value;
                    }
                }
            }
        });
    }
    setGdsAttributes() {
        if (this.dataSrc === 'ms-content') {
            for (const attr of this.tcmMetaAttributes) {
                this.gdsComponent.setAttribute(attr.key, attr.value);
            }
        }
        else {
            if (!this.tcmMetaAttributes?.length)
                return;
            this.tcmMetaAttributes.forEach((keyValue) => {
                if (keyValue) {
                    const _key = get(keyValue, 'key.Values[0]');
                    const _value = get(keyValue, 'value.Values[0]');
                    if (_value !== '{{data}}') {
                        this.gdsComponent.setAttribute(_key, _value);
                    }
                }
            });
        }
    }
    setGdsTagType() {
        if (!!this.tcmMetaTagType) {
            this.gdsComponent.setAttribute('tag-type', this.tcmMetaTagType);
        }
    }
    setGdsContrast() {
        this.contrast = this.utilities.getContrast();
        this.gdsComponent.setAttribute('contrast', this.contrast);
    }
    setGdsTheme() {
        this.theme = get(this.data, 'theme', '');
        if (!!this.theme) {
            this.gdsComponent.setAttribute('theme', this.theme);
        }
    }
    specificParsers() {
        switch (this.gdsElementTag) {
            case 'gds-comparison-table':
                this.gdsData = this.gdsComparisonTableService.setComparisonTableData(this.gdsData);
                break;
            case 'gds-swimlane':
                this.gdsSwimlaneService.filterSwimlaneItems(this.data, this.gdsData);
                break;
            case 'gds-content-feature-four':
                this.gdsSwimlaneService.filterSwimlaneItems(this.tcmContent, this.gdsData);
                break;
            case 'gds-flexible-container':
                this.gdsFlexibleContainerService.init();
                break;
        }
        this.setGdsData();
        this.addToView();
    }
    setGdsData() {
        this.gdsComponent.data = this.gdsData;
    }
    addToView() {
        this.renderer.appendChild(this.element.nativeElement, this.gdsComponent);
    }
    attachBtnInterceptor() {
        this.gdsButtonService.init(this.element, this.data, this.dataSrc);
    }
}
GdsTcmLoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsTcmLoaderComponent, deps: [{ token: DOCUMENT }, { token: i0.ElementRef }, { token: i1$2.GdsDataModelService }, { token: GdsSwimlaneService }, { token: GdsComparisonTableService }, { token: GdsFlexibleContainerService }, { token: GdsButtonService }, { token: i0.Renderer2 }, { token: i1.GdsCommonUtilityService }], target: i0.ɵɵFactoryTarget.Component });
GdsTcmLoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: GdsTcmLoaderComponent, selector: "upr-gds-tcm-loader", inputs: { data: "data" }, ngImport: i0, template: ``, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsTcmLoaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'upr-gds-tcm-loader',
                    template: ``,
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef }, { type: i1$2.GdsDataModelService }, { type: GdsSwimlaneService }, { type: GdsComparisonTableService }, { type: GdsFlexibleContainerService }, { type: GdsButtonService }, { type: i0.Renderer2 }, { type: i1.GdsCommonUtilityService }]; }, propDecorators: { data: [{
                type: Input
            }] } });

class GdsTcmLoaderModule {
}
GdsTcmLoaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsTcmLoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsTcmLoaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsTcmLoaderModule, declarations: [GdsTcmLoaderComponent], imports: [GdsCommonUtilityModule, GdsDataModelModule, GdsModalModule], exports: [GdsTcmLoaderComponent] });
GdsTcmLoaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsTcmLoaderModule, providers: [
        GdsModalService,
        PageLabelsResolver,
        GdsPoiService,
        SessionStorageService,
        GdsRouteResolverService,
        GdsTextService,
        GdsTripAdvisorService,
        GdsYoutubeService,
        GdsDataModelService,
        GdsButtonModelService,
        GdsImageLinkModelService,
        GdsPictureModelService,
        GdsVideoModelService,
        LocaleService,
        LocalStorageService,
    ], imports: [[GdsCommonUtilityModule, GdsDataModelModule, GdsModalModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsTcmLoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [GdsTcmLoaderComponent],
                    imports: [GdsCommonUtilityModule, GdsDataModelModule, GdsModalModule],
                    exports: [GdsTcmLoaderComponent],
                    providers: [
                        GdsModalService,
                        PageLabelsResolver,
                        GdsPoiService,
                        SessionStorageService,
                        GdsRouteResolverService,
                        GdsTextService,
                        GdsTripAdvisorService,
                        GdsYoutubeService,
                        GdsDataModelService,
                        GdsButtonModelService,
                        GdsImageLinkModelService,
                        GdsPictureModelService,
                        GdsVideoModelService,
                        LocaleService,
                        LocalStorageService,
                    ],
                }]
        }] });

export { GdsTcmLoaderComponent, GdsTcmLoaderModule };
